import React from 'react';
import {Tooltip} from 'components/Tooltip';
import {getStrategyProfit} from './helpers';
import {HintIcon} from './icons';
import './prediction.scss';

const Prediction = ({strategy, results, noRenderProgress, noRenderPrediction}) => {
  const renderProgress = (progress, picks, daysLeft) => (
    <div>
      <div className="progress-line">
        <div className="progress-line-active" style={{width: `${progress}%`}} />
      </div>
      <div className="prediction-progress">
        <div className="prediction-text">PROGRESS</div>
        <div className="prediction-text">
          ~{picks} picks / {(daysLeft / 7).toFixed(0)} weeks left
        </div>
      </div>
    </div>
  );

  const renderPrediction = profit => (
    <div className="prediction-info">
      <Tooltip
        text="With betting, your money is at risk. Any historical returns, expected returns, or probability projections may not reflect actual future performance."
        className="tooltip-hint"
      >
        <HintIcon />
      </Tooltip>
      <div className="prediction-profit">
        <div className="potential-profit">{getStrategyProfit(profit)}</div>
        <div className="prediction-text">Potential Profit</div>
      </div>
    </div>
  );

  const {profit, picks, daysLeft} = results.prediction;
  const startStrategyDate = strategy.createdAt._seconds;
  const lastEventDate = strategy.expirationDate._seconds;

  const progress = ((Date.now() / 1000 - startStrategyDate) / (lastEventDate - startStrategyDate)) * 100;

  return (
    <div className="prediction">
      {!noRenderPrediction && renderPrediction(profit)}
      {!noRenderProgress && renderProgress(progress, picks, daysLeft)}
    </div>
  );
};

export default Prediction;
